<!-- 水表厂家在线率、故障率 -->
<template>
  <div class="meter-online-fault-panel">
    <div class="panel-header">
      <h3 class="panel-title">{{ $t('水表在线率') }}</h3>
    </div>
    <div class="panel-body">
      <div ref="chart" class="chart-container"></div>
    </div>
  </div>
</template>
<script>
  // import echarts from 'echarts/lib/echarts';
  import echarts from 'echarts';
  import {
    postAction
  } from '@/api/manage'
  export default {
    props: {
      titleImage: {
        type: String,
        default: ''
      },
    },
    data() {
      return {
        title: this.$t('水表在线率'),
        url: {
          queryLargeScreenMeterFactory: "/jeecg-charge/meter/meterReadingLargeScreen/queryLargeScreenMeterFactory"
        },
        option: {},
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.getData();
      },
      getData(){
        postAction(this.url.queryLargeScreenMeterFactory,{}).then(res=>{
          if(res.success){
            var data = res.result;
            this.setOption(data);
          }
        })
      },
      setOption(list) {
        const chartDom = this.$refs.chart;
        const myChart = echarts.init(chartDom);
        const xData = list.xdata;
        const yData = [];
        const yData1 = [];
        list.ydata.forEach(item => {
          yData.push(item.num);
          yData1.push(item.rate * 100);
        });
        
        const option = {
          backgroundColor: 'transparent',
          textStyle: {
            color: '#ffffff'
          },
          grid: {
            top: '20%',
            left: '3%',
            right: '3%',
            bottom: '10%',
            containLabel: true
          },
          tooltip: {
            trigger: 'axis',
            formatter: '{b}<br />{a0}: {c0}<br />{a1}: {c1}%',
            backgroundColor: 'rgba(4, 22, 44, 0.9)',
            borderColor: 'rgba(0, 168, 255, 0.3)',
            borderWidth: 1,
            borderRadius: 4,
            textStyle: {
              color: '#ffffff',
              fontSize: 12
            },
            axisPointer: {
              type: 'line',
              lineStyle: {
                color: 'rgba(0, 168, 255, 0.8)'
              }
            }
          },
          legend: {
            show: true,
            top: '2%',
            right: 'center',
            itemHeight: 12,
            itemWidth: 20,
            textStyle: {
              color: '#D1F3FF',
              fontSize: 12
            }
          },
          color: ['#00ffc8', '#ff6666'],
          xAxis: [{
            type: 'category',
            data: xData,
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              color: '#D1F3FF',
              fontSize: 11,
              rotate: 0
            },
            axisPointer: {
              type: 'shadow'
            }
          }],
          yAxis: [{
            type: 'value',
            name: this.$t('数量'),
            nameTextStyle: {
              color: '#D1F3FF',
              fontSize: 12,
              padding: [0, 0, 0, 5]
            },
            axisLabel: {
              color: '#D1F3FF',
              fontSize: 11,
              formatter: '{value}'
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: ['rgba(0, 168, 255, 0.1)']
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            }
          }, {
            type: 'value',
            min: 0,
            max: 100,
            interval: 20,
            name: this.$t('在线率'),
            nameTextStyle: {
              color: '#D1F3FF',
              fontSize: 12,
              padding: [0, 5, 0, 0]
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              formatter: '{value}%',
              color: '#D1F3FF',
              fontSize: 11
            }
          }],
          series: [
            {
              name: this.$t('数量'),
              type: 'bar',
              barWidth: 16,
              data: yData,
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#00ffc8' },
                  { offset: 1, color: '#00a085' }
                ]),
                borderRadius: [2, 2, 0, 0]
              },
              emphasis: {
                itemStyle: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: '#00ffed' },
                    { offset: 1, color: '#00c49f' }
                  ])
                }
              }
            },
            {
              name: this.$t('在线率'),
              type: 'line',
              yAxisIndex: 1,
              data: yData1,
              smooth: true,
              symbol: 'circle',
              symbolSize: 6,
              lineStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  { offset: 0, color: '#ff6666' },
                  { offset: 1, color: '#ff3333' }
                ]),
                width: 3
              },
              itemStyle: {
                color: '#ff6666',
                borderColor: '#ffffff',
                borderWidth: 1
              },
              emphasis: {
                itemStyle: {
                  color: '#ff3333',
                  borderColor: '#ffffff',
                  borderWidth: 2
                }
              }
            }
          ]
        };
        myChart.setOption(option);
      }
    },
  }
</script>
<style lang="less" scoped>
.meter-online-fault-panel {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 15px;
  background: linear-gradient(135deg, rgba(0, 168, 255, 0.05) 0%, rgba(0, 0, 0, 0.1) 100%);
  border-radius: 8px;
  border: 1px solid rgba(0, 168, 255, 0.1);
  box-shadow: 0 0 20px rgba(0, 168, 255, 0.1);
}

.panel-header {
  margin-bottom: 15px;
  text-align: center;
}

.panel-title {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  margin: 0;
  text-shadow: 0 0 10px rgba(0, 168, 255, 0.5);
}

.panel-body {
  flex: 1;
  min-height: 0;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at center, rgba(0, 168, 255, 0.05) 0%, transparent 70%);
    pointer-events: none;
  }
}

.chart-container {
  height: 100%;
  width: 100%;
}

@media (max-width: 1200px) {
  .meter-online-fault-panel {
    padding: 10px;
  }
  
  .panel-title {
    font-size: 14px;
  }
}
</style>